export const GoogleMapsConstants = {
    API_KEY: 'AIzaSyCgcddwJqVXAtBb7zxFM5k6KkZMbfVZXUE',
    MAP_ID: 'dff63a1da8a8d49173c0213c',
} as const;
